// https://vuex.vuejs.org/en/actions.html

import vendorService from '@/services/vendorService'
import store from '@/store'

export default {
  async RefreshVendors (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Vendors')
    var apiResult = await vendorService.get()
    if (apiResult.success) {
      context.commit('refreshVendors', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
